import { forwardRef, memo } from 'react';
// @mui
import { Box } from '@mui/material';
//
import { StyledRootScrollbar, StyledScrollbar } from './styles';
import { ScrollbarProps } from './types';
import SimpleBarCore from 'simplebar-core';

// ----------------------------------------------------------------------

const Scrollbar = memo(
  forwardRef<HTMLElement | SimpleBarCore, ScrollbarProps>(function (
    { children, sx, ...other }: ScrollbarProps,
    ref
  ) {
    const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

    if (isMobile) {
      return (
        <Box ref={ref} sx={{ overflowX: 'auto', ...sx }} {...other}>
          {children}
        </Box>
      );
    }

    return (
      <StyledRootScrollbar>
        <StyledScrollbar
          ref={ref as React.RefObject<SimpleBarCore>}
          clickOnTrack={false}
          sx={sx}
          {...other}
        >
          {children}
        </StyledScrollbar>
      </StyledRootScrollbar>
    );
  })
);

export default Scrollbar;
